// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
import uuid from 'uuid/v4';

import { DecorationSet } from '@atlaskit/editor-prosemirror/view';

import type { AIDefinitionsPluginConfig } from '../../types';

import type { AIDefinitionsPluginState } from './types';

/**
 * Get the initial state of the plugin,
 * we also use this to reset the plugin state when doc content changed
 */
export function getInitialState({
	config,
}: {
	config: AIDefinitionsPluginConfig;
}): AIDefinitionsPluginState {
	return {
		enabled: config.enabled ?? true,
		autoHighlightEnabled: config.autoHighlightEnabled ?? true,
		enablementSource: config.enablementSource,
		// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
		keywordDecorationsSessionId: uuid(),
		keywordDecorationsSessionCounter: 0,
		keywordDecorations: DecorationSet.empty,
		isReadingAidsPopupOpen: false,
		isReadingAidsPopupLoading: false,
	};
}
